import GaEvent from './GaEvent';

export default class SearchResultClickedGaEvent extends GaEvent {
  constructor() {
    super('search_result_clicked');
  }
}
